// extracted by mini-css-extract-plugin
export var contentBody = "_7x-9";
export var headerImage = "_7x-2";
export var imageButton = "_7x-7";
export var imageButtonIcon = "_7x-8";
export var imageHeader = "_7x-4";
export var imageHeaderText = "_7x-5";
export var imageOverlay = "_7x-3";
export var imageTitle = "_7x-6";
export var imageWrapper = "_7x-1";
export var taskList = "_7x-a";
export var widget = "_7x-0";